import script from "./KefuWidget.vue?vue&type=script&lang=js"
export * from "./KefuWidget.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__